import { Outlet } from "react-router-dom";

import { SecondaryNavigation } from "@/components/secondary-navigation";
import { NavigationGroup } from "@/types/navigation";
import { useTranslation } from "react-i18next";

import { CongressPreview } from "../congress-preview";
import { DoMigration } from "../do-migration";
import { Separator } from "../ui/separator";

export function CongressSettingsLayout() {
  const { t } = useTranslation();

  const navigation: NavigationGroup[] = [
    {
      elements: [
        { name: t("nav.details"), href: `/congress/details` },
        { name: t("nav.section"), href: `/congress/sessions` },
        { name: t("nav.abstract"), href: `/congress/abstracts` },
      ],
    },
  ];
  return (
    <div>
      <div className="grid grid-cols-12 gap-x-8">
        <div className="col-span-12 mb-4 md:block lg:col-span-3">
          <SecondaryNavigation navigations={navigation} />
          <Separator className="my-4" />
          <DoMigration />
          <CongressPreview />
        </div>
        <div className="col-span-12 lg:col-span-9">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
